<template>
  <el-tabs v-model="activeName">
    <el-tab-pane label="增加传感器" name="first">
      <div class="addSensor_form">
        <el-form ref="form" :model="form" label-width="120px" class="demo-ruleForm">
          <el-form-item label="*选择生产单元">
            <el-select v-model="form.cell_id" placeholder="请选择生产单元" >
              <div v-for="cell in listPond" :key="cell.id">
                <el-option :label="cell.name" :value="cell.id"></el-option>
              </div>
            </el-select>
          </el-form-item>
          <el-form-item label="*传感器名称">
            <el-input v-model="form.sensor_name" placeholder="自定义"></el-input>
          </el-form-item>
          <el-form-item label="*终端">
            <el-select v-model="form.sensor_term_id" placeholder="请选择终端" >
              <div v-for="(term,index) in listTerm" :key="index">
                <el-option :label="term.name" :value="term.id"></el-option>
              </div>
            </el-select>
          </el-form-item>
          <el-form-item label="*传感器地址标识">
            <el-input v-model="form.sensor_addr" placeholder="范围：1-255"></el-input>
          </el-form-item>
          <el-form-item label="*产品名称">
            <el-select v-model="form.product" placeholder="请选择产品" >
              <div v-for="(sensorType,index) in listSensorType" :key="index">
                <el-option :label="sensorType" :value="sensorType"></el-option>
              </div>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">确定增加</el-button>
            <el-button @click="cancel">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  data () {
    return {
      activeName: 'first',
      form: {
        cell_id: '',
        sensor_name: '',
        product: '',
        sensor_term_id: '',
        sensor_addr: ''
      },
      listPond: {},
      listSensorType: {},
      listTerm: {},
      listTermmanu: ''
    }
  },
  methods: {
    onSubmit () {
      let formdata = new FormData()
      formdata.append('cell_id', this.form.cell_id)
      formdata.append('term_id', this.form.sensor_term_id)
      formdata.append('product', this.form.product)
      formdata.append('addr', this.form.sensor_addr)
      formdata.append('sensor_name', this.form.sensor_name)
      this.axios.post(this.$store.state.ip + 'sensordef/addSensor', formdata,
        {
          headers: {'Authorization': 'Bearer ' + window.sessionStorage.getItem('token')}
        }).then(res => {
        if (res.data.msg === 'SUCCESS') {
          this.$message.success('传感器添加成功')
          this.form = {}
        }
      }).catch(err => {
        this.$message.error('传感器添加失败')
        console.log(err)
      })
    },
    getSensorType () {
      // 获取 终端厂商及产品
      this.axios.get(this.$store.state.ip + 'termdef/listTermManus',
        {
          headers: {'Authorization': 'Bearer ' + window.sessionStorage.getItem('token')}
        }).then(res => {
        let test = res.data.data
        for (let i = 0; i < this.listTerm.length; i++) {
          if (this.listTerm[i].id === this.form.sensor_term_id) {
            this.listTermmanu = this.listTerm[i].manu
            break
          }
        }
        for (let i = 0; i < test.length; i++) {
          if (this.listTermmanu === test[i].manu) {
            this.listSensorType = test[i].products
            break
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    cancel () {
      this.form = {}
    }
  },
  created () {
    // 获取当前用户的生产单元信息
    this.axios.get(this.$store.state.ip + 'celldef/listUserCells',
      {
        params: {'username': window.sessionStorage.getItem('username')},
        headers: {'Authorization': 'Bearer ' + window.sessionStorage.getItem('token')}
      }).then(res => {
      this.listPond = res.data.data.list
      // console.log(res.data.data.list)
    }).catch(err => {
      console.log(err)
    })
    // 获取 用户的所有终端
    this.axios.get(this.$store.state.ip + 'termdef/listTermsByUsr',
      {
        params: {'user_name': window.sessionStorage.getItem('username')},
        headers: {'Authorization': 'Bearer ' + window.sessionStorage.getItem('token')}
      }).then(res => {
      this.listTerm = res.data.data.list
      for (let i = 0; i < this.listTerm.length; i++) {
        this.listTerm[i].id = this.listTerm[i].id.toString()
      }
    }).catch(err => {
      console.log(err)
    })
  },
  watch: {
    'form.sensor_term_id': function () {
      if (this.form.sensor_term_id !== '0') {
        this.getSensorType()
      }
    }
  }
}
</script>

<style scoped>
  .addSensor_form {
    width: 450px;
    margin-left: 20px;
    margin-top: 30px;
  }
  .el-input, .el-select {
    margin-left: 10px;
    width: 350px;
  }
</style>



// WEBPACK FOOTER //
// src/components/setting/addSensor.vue